export const css = {
    root: '_1klYJrab',
    ' _key': 'cut-scores/cut-scores'
};
export default css;
